export const appDevFAQs = [
  {
    id: 1,
    question: "Welche Programmiersprachen und Frameworks kommen in der App-Entwicklung zum Einsatz?",
    answer:
      "Wir arbeiten vorwiegend mit Swift (iOS), Kotlin (Android) sowie plattformübergreifenden Frameworks wie React Native und Flutter. Diese Technologien ermöglichen es uns, performante und benutzerfreundliche Apps für unterschiedliche Plattformen zu entwickeln.",
  },
  {
    id: 2,
    question: "Brauche ich Vorkenntnisse, um mit Ihnen zusammenzuarbeiten?",
    answer:
      "Nein, Sie müssen keine Programmier- oder Technikkenntnisse mitbringen. Wir übernehmen sämtliche Schritte von der Konzeption über das Design bis zur Entwicklung und unterstützen Sie dabei, Ihre Ideen in eine erfolgreiche App zu verwandeln. Selbstverständlich arbeiten wir eng mit Ihnen zusammen und erklären alle wichtigen Entscheidungen verständlich.",
  },
  {
    id: 3,
    question: "Wie lange dauert es, eine vollständige App zu entwickeln?",
    answer:
      "Das hängt stark von der Komplexität und den gewünschten Features ab. Eine einfache App mit Basisfunktionen lässt sich oft innerhalb von zwei bis drei Monaten realisieren. Für größere Projekte mit komplexer Backend-Anbindung oder speziellen Sicherheitsanforderungen sollten Sie mit vier bis sechs Monaten Entwicklungszeit rechnen.",
  },
  {
    id: 4,
    question: "Bieten Sie auch plattformübergreifende (Cross-Platform) Lösungen an?",
    answer:
      "Ja, wir entwickeln sowohl native Apps für iOS und Android als auch Cross-Platform-Anwendungen mit React Native oder Flutter. Damit können wir eine kosteneffiziente Entwicklung gewährleisten, ohne Kompromisse bei Performance oder Benutzererlebnis einzugehen.",
  },
  {
    id: 5,
    question: "Wie sieht es mit Wartung und regelmäßigen Updates aus?",
    answer:
      "Nach dem Launch Ihrer App lassen wir Sie nicht allein. Wir bieten verschiedene Wartungs- und Supportpakete an, um Ihre App aktuell, sicher und stabil zu halten. Dazu gehören regelmäßige Updates der Frameworks, Sicherheitsprüfungen und auf Wunsch auch das Einspielen neuer Features.",
  },
  {
    id: 6,
    question: "Wie stellen Sie die Datensicherheit und den Schutz der Nutzerdaten sicher?",
    answer:
      "Wir integrieren moderne Sicherheitsmechanismen wie verschlüsselte Kommunikation (SSL/TLS), sichere Authentifizierungsverfahren und regelmäßige Penetrationstests. Außerdem halten wir uns an Datenschutzrichtlinien wie die DSGVO, um die persönlichen Daten Ihrer Nutzer zu schützen.",
  },
  {
    id: 7,
    question: "Wie funktioniert die Beta-Phase und das Testen der App?",
    answer:
      "Vor dem offiziellen Release durchläuft Ihre App eine ausführliche Testphase. Hier führen wir interne und externe Beta-Tests durch, um Bugs, Performanceprobleme und UX-Hürden zu identifizieren. Mit Tools wie TestFlight (iOS) oder Google Play Console (Android) können wir Feedback einholen und die App kontinuierlich verbessern.",
  },
];

export const appDevIntro = {
  title: "App-Entwicklung FAQs",
  subtitle: "Antworten auf Ihre wichtigsten Fragen",
  description:
    "Hier finden Sie ausführliche Informationen zu unseren Leistungen, dem Entwicklungsprozess und technischen Details. Sollten Sie weitere Fragen haben, kontaktieren Sie uns gerne direkt für eine persönliche Beratung.",
};
